const headerStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "15px",
    alignItems: "center",
    width: "100%",
    marginBottom: "15px",
  },
  textField: {
    width: { xs: "100%", sm: "auto" },
    "& .MuiOutlinedInput-root": {
      width: { xs: "100%", sm: "220px" },
      height: "39px",
      fontWeight: 400,
      fontSize: "14px",
      color: "rgba(62, 63, 76, 0.7)",
      borderRadius: "8px",
      backgroundColor: "#ffffff",
      "& input": {
        paddingY: "10px",
      },
      "& fieldset": {
        borderWidth: "1px",
        borderColor: "#EAEAEA",
      },
      "&:hover fieldset": {
        borderWidth: "1px",
        borderColor: "#3e3f4c",
      },
      "&.Mui-focused fieldset": {
        borderWidth: "1px",
        borderColor: "#3e3f4c",
      },
    },
  },
  clearButtonStyles: {
    background: "none",
    textDecorationLine: "underline !important",
    textWrap: "nowrap",
    color: "#2F2B3DE5",
    fontSize: 15,
    textTransform: "none",
    textUnderlineOffset: "4px",
    "&:hover": { textDecorationColor: "#46a091" },
  },
};

export default headerStyles;
